import _ from "lodash";
import {getItemFromSession, writeSession} from "../../sharedGlobal";
import {
  moduleNamespace,
  SET_SOFTWARE_PRICES,
  SOFTWARE_PRODUCT_CONTENT_FALLBACKS,
  SUPPORT_ADDON_CONTENT_FALLBACKS, SET_ERRORS,
} from "./constants";
import {validateSoftwareProduct} from "./schema/product";

/**
 * Get the default pricing structure for the resellable software product.
 */
export function getDefaultSoftwareProduct() {
  return {
    name: SOFTWARE_PRODUCT_CONTENT_FALLBACKS.name,
    prices: getDefaultPrices(),
  };
}

/**
 * Get the default pricing structure for the resellable software support addon product.
 */
export function getDefaultSupportAddon() {
  return {
    name: SUPPORT_ADDON_CONTENT_FALLBACKS.name,
    prices: getDefaultPrices(),
  };
}

/**
 * Get the default pricing structure for a resellable product.
 */
export function getDefaultPrices() {
  return {
    GBP: {
      monthlyRaw: 0,
      annualRaw: 0,
    },
    USD: {
      monthlyRaw: 0,
      annualRaw: 0,
    },
  };
}

/**
 * JSON encode and write the user-created software product to session.
 */
export function writeSoftwareProductToSession(product) {
  writeSession(
    moduleNamespace,
    'softwareProduct',
    JSON.stringify(product)
  );
}

/**
 * JSON encode and write the user-created software support addon to session.
 */
export function writeSupportAddonToSession(addon) {
  writeSession(
    moduleNamespace,
    'supportAddon',
    JSON.stringify(addon)
  );
}
